export default __webpack_public_path__ + "static/media/about2.0d542674.webp";